import { useCrudActions } from '@/common/view/useCrudActions';
import { mailService } from '@/services/mail';
import useVuelidate from '@vuelidate/core';
import { email, required } from '@vuelidate/validators';
import { reactive } from 'vue';

export function useMailSetting() {
    const crudAction = useCrudActions();

    const model = reactive({
        hasData: false,
        name: '',
        email: '',
        type: null
    });

    const validations = {
        name: { required },
        email: { required, email },
        type: { required }
    };

    const v$ = useVuelidate(validations, model);

    const fetch = crudAction.executeAction({
        request: mailService().get,
        onSuccess: ({ data }) => {
            model.hasData = true;
            model.name = data.name;
            model.email = data.email;
            model.type = data.type;
        },
        onError: () => {
            model.hasData = false;
            model.name = '';
            model.email = '';
            model.type = null;
        }
    });

    const actions = {
        update: crudAction.excuteAndNotify({
            validator: v$,
            request: () => mailService().update(model.name, model.email, model.type),
            onSuccess: fetch
        }),
        remove: crudAction.confirmAndRemove({
            request: mailService().remove,
            onSuccess: fetch,
            onFinally: () => v$.value.$reset()
        })
    };

    return { v$, model, fetch, actions };
}
